// Environment Configuration Utility
export const config = {
  // API Configuration
  api: {
    baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:4000/api/v1',
    timeout: 10000, // 10 seconds
  },
  
  // App Configuration
  app: {
    name: process.env.REACT_APP_APP_NAME || 'Banner Admin Panel',
    version: process.env.REACT_APP_VERSION || '1.0.0',
    environment: process.env.REACT_APP_ENVIRONMENT || 'development',
  },
  
  // Environment checks
  isDevelopment: process.env.REACT_APP_ENVIRONMENT === 'development' || process.env.NODE_ENV === 'development',
  isProduction: process.env.REACT_APP_ENVIRONMENT === 'production' || process.env.NODE_ENV === 'production',
  
  // Debug configuration
  debug: {
    enabled: process.env.REACT_APP_ENVIRONMENT === 'development',
    logApiCalls: process.env.REACT_APP_ENVIRONMENT === 'development',
  }
};

// Log configuration on app start
console.log('🚀 App Configuration:', {
  environment: config.app.environment,
  apiBaseURL: config.api.baseURL,
  appName: config.app.name,
  version: config.app.version,
  isDevelopment: config.isDevelopment,
  isProduction: config.isProduction,
});

// Log all environment variables for debugging
console.log('🔧 Environment Variables:', {
  REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  REACT_APP_ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
  REACT_APP_APP_NAME: process.env.REACT_APP_APP_NAME,
  REACT_APP_VERSION: process.env.REACT_APP_VERSION,
  NODE_ENV: process.env.NODE_ENV,
});

export default config;
